import { useContext } from "react";

import {
  RenameDocumentContext,
  type RenameDocumentReturn,
} from "../contexts/RenameDocumentContext";

export const useRenameDocumentModal = (): RenameDocumentReturn => {
  const context = useContext(RenameDocumentContext);
  if (!context) {
    throw new Error(
      "useRenameDocumentModal must be used within a RenameDocumentProvider",
    );
  }
  return context;
};
